<template>
  <tr>
    <td v-for="(header, index) in headers" :key="index">
      <slot :item="item" :name="`item.${header.value}`">
        <div v-if="header.type === 'text-editor'">
          <v-menu
            v-model="titleEditMode"
            offset-y
            :close-on-content-click="false"
          >
            <template v-slot:activator="{ on, attrs }">
              <span v-bind="attrs" v-on="on">{{ item.title }}</span>
            </template>
            <v-card class="pt-1 pl-2 pr-2" min-width="45vw">
              <div class="pt-4 px-1 pb-0 height-textarea">
                <v-textarea
                  v-model="title"
                  :error-messages="$v.title.$error ? errors.TITLE : []"
                  :hide-details="true"
                  outlined
                  label="Найменування"
                />
              </div>
              <v-card-actions>
                <v-spacer />
                <v-btn color="red lighten-2" text @click="updateTitle()">
                  Зберегти
                </v-btn>
                <v-btn color="grey" text @click="closeTitleEditor()">
                  Відмінити
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-menu>
        </div>
        <div v-else-if="header.type === 'estimate-editor'">
          <span v-if="item.isTestSection">{{ item[header.value] }}</span>
          <EstimateMenu
            v-else
            :item="item"
            :header="header.value"
            @update="
              (item) => {
                $emit('updateEstimate', item);
              }
            "
          />
        </div>
        <div v-else-if="header.type === 'jira-editor'">
          <v-menu
            v-if="!item.isTestSection"
            v-model="jiraEditMode"
            offset-y
            :close-on-content-click="false"
          >
            <template #activator="{ on: onMenu }">
              <v-icon
                v-if="!item.issueJiraDev && !item.issueJiraAnalyst"
                v-on="onMenu"
                small
                @click="openJiraEditor(item)"
              >
                mdi-jira
              </v-icon>
              <v-tooltip v-else bottom>
                <template v-slot:activator="{ on: onTooltip }">
                  <span>
                    <v-icon
                      small
                      v-on="{ ...onMenu, ...onTooltip }"
                      :color="item.overlimit > 0 ? 'red' : 'blue darken-1'"
                      @click="openJiraEditor(item)"
                      >mdi-jira
                    </v-icon>
                  </span>
                </template>
                <div>
                  <span
                    >Факт:
                    {{ item.totalTimeSpentSeconds | secondsToHours }}</span
                  ><br />
                  <span>Факт з грейдами: {{ item.factWithGrades }}</span
                  ><br />
                  <span v-if="calcOverlimitItem(item) > 0"
                    >Переліміт від t(avg): {{ item.overlimit }}</span
                  >
                </div>
              </v-tooltip>
            </template>
            <v-card class="pt-1 pl-2 pr-2">
              <div class="d-flex align-center pt-2 pl-2 pr-2">
                <v-row>
                  <v-col>
                    <CustomTextField
                      v-model="tmpJiraTrackers.issueJiraAnalyst"
                      label="Оцінка задачі"
                      append-icon="search"
                      @click:append="
                        redirectTrackerRef(tmpJiraTrackers.issueJiraAnalyst)
                      "
                    />
                  </v-col>
                  <v-col>
                    <CustomTextField
                      v-model="tmpJiraTrackers.issueJiraDev"
                      label="Реалізація задачі"
                      append-icon="search"
                      @click:append="
                        redirectTrackerRef(tmpJiraTrackers.issueJiraDev)
                      "
                    />
                  </v-col>
                </v-row>
              </div>
              <v-card-actions class="pt-0">
                <v-spacer />
                <v-btn
                  color="red lighten-2"
                  text
                  @click="saveJiraTrackers(item)"
                >
                  Зберегти
                </v-btn>
                <v-btn color="grey" text @click="closeJiraEditor(item)">
                  Відмінити
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-menu>
          <v-edit-dialog
            v-else
            :large="true"
            save-text="Зберегти"
            cancel-text="Вiдмiнити"
            @save="$emit('updateTestIndex', item)"
          >
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <span>
                  <v-icon small v-bind="attrs" v-on="on">
                    mdi-calculator-variant
                  </v-icon>
                </span>
              </template>
              <span>Змінити коефіцієнт тестування</span>
            </v-tooltip>
            <template v-slot:input>
              <div class="d-flex align-center pa-4 pl-0 pr-0">
                <CustomTextField
                  v-model="item.testIndex"
                  label="Коефіцієнт тестування"
                />
              </div>
            </template>
          </v-edit-dialog>
        </div>
        <div v-else-if="header.type === 'menu'">
          <MenuRow
            :disabled="item.isTestSection"
            :show="item.isTestSection"
            :actions="actions"
            @show-section-dialog="$emit('showSectionDialog', item)"
            @show-section-item-delete-dialog="
              $emit('showSectionItemConfirmDialog', item)
            "
          />
        </div>
        <div v-else>
          {{ item[header.value] }}
        </div>
      </slot>
    </td>
  </tr>
</template>

<script>
import MenuRow from "../../../components/MenuRow.vue";
import EstimateMenu from "../specifications/EstimateMenu.vue";
import { required } from "vuelidate/lib/validators";
import { ERRORS } from "@/helpers";
export default {
  components: { MenuRow, EstimateMenu },
  props: {
    item: {
      type: Object,
      default: () => {
        return {};
      },
    },
    headers: {
      type: Array,
      default: () => {
        return [];
      },
    },
    actions: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  data: () => ({
    title: "",
    titleEditMode: false,
    jiraEditMode: false,
    tmpJiraTrackers: {
      issueJiraDev: null,
      issueJiraAnalyst: null,
    },
  }),
  computed: {
    errors() {
      return {
        TITLE: [ERRORS.REQUIRED],
      };
    },
  },
  watch: {
    item: {
      handler() {
        this.setTitle();
      },
      immediate: true,
    },
  },
  validations: {
    title: {
      required,
    },
  },
  methods: {
    calcOverlimitItem(item) {
      return (item.overlimit = item.factWithGrades - item.tAvg);
    },
    redirectTrackerRef(issueTrackerRef) {
      if (issueTrackerRef) {
        window.open(
          "https://atominc.atlassian.net/browse/" + issueTrackerRef,
          "_blank"
        );
      }
    },
    setTitle() {
      this.title = this.item?.title || "";
    },
    updateTitle() {
      this.$v.$touch();
      if (this.$v.title.$invalid) {
        return;
      }
      this.$emit("updateTitle", { id: this.item.id, title: this.title });
      this.closeTitleEditor();
    },
    closeTitleEditor() {
      this.titleEditMode = false;
    },
    openJiraEditor(item) {
      this.tmpJiraTrackers.issueJiraDev = item.issueJiraDev;
      this.tmpJiraTrackers.issueJiraAnalyst = item.issueJiraAnalyst;
    },
    saveJiraTrackers(item) {
      item.issueJiraDev = this.tmpJiraTrackers.issueJiraDev;
      item.issueJiraAnalyst = this.tmpJiraTrackers.issueJiraAnalyst;
      this.$emit("updateTrack", item);
      this.closeJiraEditor();
    },
    closeJiraEditor() {
      this.jiraEditMode = false;
    },
  },
};
</script>
<style>
.height-textarea textarea {
  height: 120px;
  overflow: auto;
}
</style>
